import type { ButtonColor } from '@freelancer/ui/button';
import { literalsToArray } from '../helpers';

export type CardLevel = 'primary' | 'secondary' | 'tertiary' | 'none';
export type CardHighlightColor = 'blue';
export type CardBorder =
  | 'none'
  | 'solid'
  | 'solid-dark'
  | 'solid-light'
  | 'dashed';
export type CardBorderColor = 'primary';
export type CardSize = 'small' | 'mid';
export type CardBorderRadius = 'mid' | 'large' | 'xlarge';

export interface CardHeaderButton {
  text: string;
  color?: ButtonColor;
  link?: string;
  fragment?: string;
  queryParams?: { [k: string]: any };
  linkActive?: string[] | string;
  linkActiveOptions?: { exact: boolean };
  busy?: boolean;
}

export const cardSizeOptions = literalsToArray<CardSize>([
  'small',
  'mid',
] as const);

export const cardLevelOptions = literalsToArray<CardLevel>([
  'none',
  'primary',
  'secondary',
  'tertiary',
] as const);

export const cardBorderOptions = literalsToArray<CardBorder>([
  'none',
  'solid',
  'solid-dark',
  'solid-light',
] as const);
